import { render, staticRenderFns } from "./EditFollowUpRecord.vue?vue&type=template&id=22eb0e28&scoped=true&"
import script from "./EditFollowUpRecord.vue?vue&type=script&lang=js&"
export * from "./EditFollowUpRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22eb0e28",
  null
  
)

export default component.exports